import { observer } from 'mobx-react-lite'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { usePostPreviewStore } from 'components/PostPreviewModalV2/PostPreviewStoreProvider'
import { useBrandKit } from 'hooks/queries/brandKits/useBrandKit'

import { Section } from '../Section/Section'
import Styles from './NonBrandKitAccounts.module.scss'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { AccountToggle } from '../AccountToggle/AccountToggle'
import { POSTABLE_PROVIDERS } from '../ChannelDropdown/ChannelDropdown'

interface NonBrandKitAccountsProps {
  accounts: ExternalIntegration[]
  selectedAccounts: ExternalIntegration[]
  onSelect: (a: ExternalIntegration) => void
}

const NonBrandKitAccountsView = ({ accounts, onSelect, selectedAccounts }: NonBrandKitAccountsProps) => (
  <div className={Styles.root}>
    {accounts.map((a) => (
      <AccountToggle
        key={a.id}
        account={a}
        onChange={() => onSelect(a)}
        isSelected={selectedAccounts.find((s) => s.id === a.id) !== undefined}
      />
    ))}
  </div>
)

export const NonBrandKitAccounts = observer(() => {
  const store = usePostPreviewStore()
  const { data: brandKitData, isLoading: brandKitLoading } = useBrandKit(store.selectedBrandKitId)
  const { data: externalIntegrationsData, isLoading: externalIntegrationsLoading } = useExternalIntegrations()

  if (brandKitLoading || externalIntegrationsLoading) return null

  const nonBrandKitAccounts =
    externalIntegrationsData?.external_integrations.filter(
      (i) =>
        POSTABLE_PROVIDERS.includes(i.provider) &&
        !brandKitData?.brand_kit.external_integrations.some((e) => e.provider === i.provider),
    ) ?? []

  if (nonBrandKitAccounts.length === 0) return null

  const onSelect = (account: ExternalIntegration) => {
    const exists = store.selectedAccounts.find((a) => a.id === account.id)
    store.setSelectedAccounts(
      exists ? store.selectedAccounts.filter((a) => a.id !== account.id) : [...store.selectedAccounts, account],
    )
  }

  return (
    <Section title="Other accounts">
      <NonBrandKitAccountsView
        accounts={nonBrandKitAccounts}
        onSelect={onSelect}
        selectedAccounts={store.selectedAccounts}
      />
    </Section>
  )
})
